import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '../views/Dashboard'
import Login from '../components/core/Login'
import Orcamentos from '../views/Orcamentos'
import Orcamento from '../views/Orcamento'
import Requisicoes from '../views/Requisicoes'
import Requisicao from '../views/Requisicao'
import Users from '../views/Users'
import Painel from '../views/painel/Painel'

Vue.use(VueRouter)

const routes = [
  {
    path: '*', redirect: '/login' //criar tela 404
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    component: Dashboard,
    meta: {
      title: 'Adapt - Analytics',
      requiresAuth: true,
      access: 'root'
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        components: {
          default: Dashboard,
        },
        meta: {
          title: 'Adapt - Analytics',
          requiresAuth: true,
          access: 'root'
        }
      },
      {
        path: '/orcamentos',
        name: 'orcamentos',
        component: Orcamentos,
        meta: {
          requiresAuth: true,
          access: 'root'
        }
      },
      {
        path: '/orcamento',
        name: 'orcamento',
        component: Orcamento,
        meta: {
          requiresAuth: true,
          access: 'root'
        }
      },
      {
        path: '/requisicoes',
        name: 'requisicoes',
        component: Requisicoes,
        meta: {
          requiresAuth: true,
          access: 'root'
        }
      },
      {
        path: '/requisicao',
        name: 'requisicao',
        component: Requisicao,
        meta: {
          requiresAuth: true,
          access: 'root'
        }
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: Users,
        meta: {
          requiresAuth: true,
          access: 'root'
        },
      },
      {
        path: '/painel',
        name: 'painel',
        component: Painel,
        meta: {
          requiresAuth: true,
          access: 'root'
        },
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
    } else {
      let user = JSON.parse(localStorage.getItem('user'));
      if (to.matched.some((record) => record.meta.access)) {
        if (user.tipo == 'root') {
          next();
        } else if (user.tipo == 'supervisor') {
          next();
        } else if (user.tipo == 'basico') {
          next()
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next();
    }
  } else {
    next();
  }
});

export default router
